import React from "react";
import { Heading, Text } from "rebass";
import styled from "styled-components";
import uuid from "uuid";
import { Link, Flex } from "./Primitives";
//

const NavigationLink = styled(({ ...props }) => (
  <Link pr={4} color="inactive" fontWeight="2" fontSize={["1"]} {...props} />
))`
  text-decoration: none;
  text-transform: capitalize;
  &:last-of-type {
    padding-right: 0;
  }
  &:hover,
  &:active {
    color: #d2dee7;
  }
`;
export function Navigation({ links, ...props }) {
  return (
    <Flex
      justifyContent="space-between"
      width={1}
      borderBottom={1}
      borderColor="lines"
      css={{
        height: "48px"
      }}
    >
      <Flex alignItems="center" width={1} bg="background" color="accentPurple">
        <Text
          fontFamily={"proxima"}
          fontWeight={2}
          fontSize={1}
          css={{
            display: "inline-block",
            flexShrink: 0
          }}
          px={2}
          color="mustard"
        >
          JS
        </Text>
        <Heading
          fontSize={[1]}
          fontWeight={2}
          letterSpacing="1"
          fontFamily={"proxima"}
          color="white"
          css={{ display: "inline-block", textTransform: "uppercase" }}
        >
          Daniel Velasquez
        </Heading>
      </Flex>
      <Flex alignItems="center" pr={[2, 6]} css={{ height: "100%" }}>
        {links.map(c => (
          <NavigationLink to={c.to} key={uuid()}>
            {c.text}
          </NavigationLink>
        ))}
      </Flex>
    </Flex>
  );
}

Navigation.defaultProps = {
  links: []
};
